<div class="popup__header-title">
    <ng-content></ng-content>
</div>
<button type="button" class="popup__header-close" (click)="onClose($event)">
    <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16">
        <path style="fill: currentColor;" d="M14.364,0.222 L15.778,1.636 L9.414,8.000 L15.778,14.364 L14.364,15.778 L8.000,9.414 L1.636,15.778 L0.222,14.364 L6.586,8.000 L0.222,1.636 L1.636,0.222 L8.000,6.586 L14.364,0.222 Z"></path>
    </svg>
</button>
